import _ from 'lodash';
import api from '@/api/managerApi';
import urlBuilder from '@/utils/urlBuilder';
import ROUTES from '@/enums/routes';

export default {
    list() {
        return api.get(urlBuilder(ROUTES.LOCATION.API.LIST))
            .then(response => Promise.resolve(_.get(response, 'data.data', [])))
            .catch(e => Promise.reject(_.get(e, 'response.data', e)));
    },

    show({ locationId }) {
        return api.get(urlBuilder(ROUTES.LOCATION.API.SHOW, { locationId }))
            .then(response => Promise.resolve(_.get(response, 'data.data', null)))
            .catch(e => Promise.reject(_.get(e, 'response.data', e)));
    },

    store(data) {
        return api.post(urlBuilder(ROUTES.LOCATION.API.STORE), data)
            .then(response => Promise.resolve(_.get(response, 'data.data', null)))
            .catch(e => Promise.reject(_.get(e, 'response.data', e)));
    },

    update(data) {
        return api.put(urlBuilder(ROUTES.LOCATION.API.UPDATE, {
            locationId: data.id
        }), data)
            .then(response => Promise.resolve(_.get(response, 'data.data', null)))
            .catch(e => Promise.reject(_.get(e, 'response.data', e)));
    },

    remove({ locationId }) {
        return api.delete(urlBuilder(ROUTES.LOCATION.API.DELETE, { locationId }))
            .then(response => Promise.resolve(_.get(response, 'data.data', null)))
            .catch(e => Promise.reject(_.get(e, 'response.data', e)));
    }
};
